import React, { useState, useEffect, setGlobal } from "reactn";
import PropTypes from "prop-types";

// hooks
import appHook from "../../../hooks/appHook";

// components
import Input from "shared-anpost-components/components/form/input/Input";
import Select from "shared-anpost-components/components/form/select/Select";
import FormGroup from "shared-anpost-components/components/form/form_group/FormGroup";
import InputGroup from "shared-anpost-components/components/form/input_group/InputGroup";
import Label from "shared-anpost-components/components/form/label/Label";
import AddElement from "shared-anpost-components/components/form/addElement/AddElement";
import FieldError from "shared-anpost-components/components/form/fieldError/FieldError";

// config
import { CountiesConfig } from "../../../config/Counties.config";

const ManualAddress = ({ addressId, handleChange, handleKeyup, handleBlur, values, errors, country }) => {
    // hooks
    const { handleFocus, focus } = appHook();

    useEffect(() => {
        const tempVals = values;
        tempVals[`${addressId}Country`] = country;

        // update the country value
        setGlobal({
            values: tempVals
        });
    }, []);

    const handleSpecialCharacterChange = event => {
        event.preventDefault();
        const eventObj = event;

        // remove any special characters and digits as user types
        eventObj.target.value = event.target.value.replace(/[^a-zA-Z-' ]/g, "");

        handleChange(eventObj);
    };

    // local state
    const [lineThree, setLineThree] = useState(false);

    return (
        <>
            <FormGroup focused={focus === `${addressId}Addresslineone` ? true : !!(false || values[`${addressId}Addresslineone`])} error={errors[`${addressId}Addresslineone`]}>
                <InputGroup>
                    <Label htmlFor={`${addressId}Addresslineone`} text="Address Line 1" />
                    <Input
                        id={`${addressId}Addresslineone`}
                        type="text"
                        name={`${addressId}Addresslineone`}
                        change={handleChange}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[`${addressId}Addresslineone`] || ""}
                        required
                        maxLength="50"
                    />
                </InputGroup>
                {errors[`${addressId}Addresslineone`] && <FieldError error={errors[`${addressId}Addresslineone`]} />}
            </FormGroup>
            <FormGroup focused={focus === `${addressId}Addresslinetwo` ? true : !!(false || values[`${addressId}Addresslinetwo`])} error={errors[`${addressId}Addresslinetwo`]}>
                <InputGroup>
                    <Label htmlFor={`${addressId}Addresslinetwo`} text={`Address Line 2 ${country === "Ireland" ? " (optional)" : ""}`} />
                    <Input
                        id={`${addressId}Addresslinetwo`}
                        type="text"
                        name={`${addressId}Addresslinetwo`}
                        change={handleChange}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[`${addressId}Addresslinetwo`] || ""}
                        required
                        maxLength="50"
                    />
                </InputGroup>
                {errors[`${addressId}Addresslinetwo`] && <FieldError error={errors[`${addressId}Addresslinetwo`]} />}
            </FormGroup>
            {!lineThree && !values[`${addressId}Addresslinethree`] && (
                <AddElement click={() => setLineThree(true)}>
                    <p>
                        <span>+</span>Add an address line
                    </p>
                </AddElement>
            )}
            {(lineThree || values[`${addressId}Addresslinethree`]) && (
                <>
                    <FormGroup focused={focus === `${addressId}Addresslinethree` ? true : !!(false || values[`${addressId}Addresslinethree`])} error={errors[`${addressId}Addresslinethree`]}>
                        <InputGroup>
                            <Label htmlFor={`${addressId}Addresslinethree`} text="Address Line 3 (optional)" />
                            <Input
                                id={`${addressId}Addresslinethree`}
                                type="text"
                                name={`${addressId}Addresslinethree`}
                                change={handleChange}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values[`${addressId}Addresslinethree`] || ""}
                                required
                                maxLength="50"
                            />
                        </InputGroup>
                        {errors[`${addressId}Addresslinethree`] && <FieldError error={errors[`${addressId}Addresslinethree`]} />}
                    </FormGroup>
                </>
            )}

            {country === "Ireland" && (
                <>
                    <FormGroup error={errors[`${addressId}Town`]} focused={focus === `${addressId}Town` ? true : !!(false || values[`${addressId}Town`])}>
                        <InputGroup>
                            <Label htmlFor={`${addressId}Town`} text="City or Town" />
                            <Input
                                id={`${addressId}Town`}
                                type="text"
                                name={`${addressId}Town`}
                                change={handleSpecialCharacterChange}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values[`${addressId}Town`] || ""}
                                maxLength="50"
                            />
                        </InputGroup>
                        {errors[`${addressId}Town`] && <FieldError error={errors[`${addressId}Town`]} />}
                    </FormGroup>
                    <FormGroup error={errors[`${addressId}Eircode`]} focused={focus === `${addressId}Eircode` ? true : !!(false || values[`${addressId}Eircode`])}>
                        <InputGroup>
                            <Label htmlFor={`${addressId}Eircode`} text="Eircode (optional)" />
                            <Input
                                id={`${addressId}Eircode`}
                                type="text"
                                name={`${addressId}Eircode`}
                                change={handleChange}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values[`${addressId}Eircode`] || ""}
                                maxLength="7"
                            />
                        </InputGroup>
                        {errors[`${addressId}Eircode`] && <FieldError error={errors[`${addressId}Eircode`]} />}
                    </FormGroup>
                    <FormGroup error={errors[`${addressId}County`]}>
                        <Select
                            id={`${addressId}County`}
                            type="text"
                            name={`${addressId}County`}
                            change={handleChange}
                            keyup={handleKeyup}
                            focused={focus === `${addressId}County` ? true : !!(false || values[`${addressId}County`])}
                            focus={handleFocus}
                            blur={handleBlur}
                            labelText="County"
                            options={CountiesConfig}
                            selectedValue={values[`${addressId}County`] || ""}
                            defaultValue="County"
                            required
                            maxLength="50"
                        />
                        {errors[`${addressId}County`] && <FieldError error={errors[`${addressId}County`]} />}
                    </FormGroup>
                </>
            )}
            {country !== "Ireland" && (
                <>
                    <FormGroup error={errors[`${addressId}City`]} focused={focus === `${addressId}City` ? true : !!(false || values[`${addressId}City`])}>
                        <InputGroup>
                            <Label htmlFor={`${addressId}City`} text="City or State" />
                            <Input
                                id={`${addressId}City`}
                                type="text"
                                name={`${addressId}City`}
                                change={handleChange}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values[`${addressId}City`] || ""}
                                maxLength="50"
                            />
                        </InputGroup>
                        {errors[`${addressId}City`] && <FieldError error={errors[`${addressId}City`]} />}
                    </FormGroup>
                    <FormGroup error={errors[`${addressId}PostCode`]} focused={focus === `${addressId}PostCode` ? true : !!(false || values[`${addressId}PostCode`])}>
                        <InputGroup>
                            <Label htmlFor={`${addressId}PostCode`} text="Postcode (optional)" />
                            <Input
                                id={`${addressId}PostCode`}
                                type="text"
                                name={`${addressId}PostCode`}
                                change={handleChange}
                                keyup={handleKeyup}
                                focus={handleFocus}
                                blur={handleBlur}
                                value={values[`${addressId}PostCode`] || ""}
                                maxLength="7"
                            />
                        </InputGroup>
                        {errors[`${addressId}PostCode`] && <FieldError error={errors[`${addressId}PostCode`]} />}
                    </FormGroup>
                </>
            )}

            {country !== "Ireland" && (
                <FormGroup disabled>
                    <InputGroup>
                        <Label htmlFor={`${addressId}Country`} text="Country" />
                        <Input id={`${addressId}Country`} type="text" name={`${addressId}Country`} value={country} disabled />
                    </InputGroup>
                </FormGroup>
            )}
        </>
    );
};

ManualAddress.propTypes = {
    addressId: PropTypes.string,
    handleChange: PropTypes.func,
    handleKeyup: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
    country: PropTypes.string
};

export default ManualAddress;
